import { createFileRoute } from "@tanstack/react-router";
import { FileContentPage } from "@/components/features/files/FileContentPage";
export const Route = createFileRoute("/_auth/file-content/$fileContentId")({
  component: ContentRoute,
});
function ContentRoute() {
  const { fileContentId } = Route.useParams();
  return <FileContentPage key={fileContentId} id={fileContentId} />;
}
